import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Picker, List, WhiteSpace } from 'antd-mobile/lib';
import Util from '../../../util.js';
import NavigatorMain from '../../NavigatorMain';
import echarts from 'echarts/lib/echarts';
import { compareDate, compareTime, get3MonthBefor, get1yearBefor, goLogin,getPayAll } from '../../../getPay';
import { hashHistory } from 'react-router';

import { getPublicProductDetil, fundPublicDetil, getHistoryProfileRate, deleteOptional, reateOptional } from '../../../action/productAction';
import ModalSelect from '../../Modal/ModalSelect';

// import { setStorage, getStorage, urlAllBase, isLoginAndRealName } from '../../CommonVar';

let historyD = {"code":"0000","message":null,"content":{"HistoryRate":[{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"164347","fund_id":"3924","publish_date":"2016-12-16","value_134":"1.002","value_124":"316568403.07","value_134_2":"1.002","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":null,"id":"0","value_zdfpct":null},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"164936","fund_id":"3924","publish_date":"2016-12-23","value_134":"1.001","value_124":"316260560.09","value_134_2":"1.001","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.10","id":"0","value_zdfpct":"-0.10"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"165703","fund_id":"3924","publish_date":"2016-12-30","value_134":"0.999","value_124":"315733128.13","value_134_2":"0.999","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.20","id":"0","value_zdfpct":"-0.20"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"165612","fund_id":"3924","publish_date":"2016-12-31","value_134":"0.999","value_124":"315726376.30","value_134_2":"0.999","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.20","id":"0","value_zdfpct":"-0.20"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"166151","fund_id":"3924","publish_date":"2017-01-06","value_134":"0.993","value_124":"313690601.59","value_134_2":"0.993","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.60","id":"0","value_zdfpct":"-0.60"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"166905","fund_id":"3924","publish_date":"2017-01-13","value_134":"0.993","value_124":"313748727.77","value_134_2":"0.993","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.00","id":"0","value_zdfpct":"0.00"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"167659","fund_id":"3924","publish_date":"2017-01-20","value_134":"0.992","value_124":"313503582.31","value_134_2":"0.992","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.10","id":"0","value_zdfpct":"-0.10"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"167902","fund_id":"3924","publish_date":"2017-01-24","value_134":"0.990","value_124":null,"value_134_2":"0.990","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.20","id":"0","value_zdfpct":"-0.20"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"167965","fund_id":"3924","publish_date":"2017-01-25","value_134":"0.992","value_124":null,"value_134_2":"0.992","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.20","id":"0","value_zdfpct":"0.20"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"168173","fund_id":"3924","publish_date":"2017-01-26","value_134":"0.993","value_124":null,"value_134_2":"0.993","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.10","id":"0","value_zdfpct":"0.10"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"168325","fund_id":"3924","publish_date":"2017-02-03","value_134":"0.993","value_124":null,"value_134_2":"0.993","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.00","id":"0","value_zdfpct":"0.00"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"168560","fund_id":"3924","publish_date":"2017-02-06","value_134":"0.995","value_124":null,"value_134_2":"0.995","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.20","id":"0","value_zdfpct":"0.20"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"168679","fund_id":"3924","publish_date":"2017-02-07","value_134":"0.996","value_124":null,"value_134_2":"0.996","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.10","id":"0","value_zdfpct":"0.10"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"168751","fund_id":"3924","publish_date":"2017-02-08","value_134":"1.000","value_124":null,"value_134_2":"1.000","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.40","id":"0","value_zdfpct":"0.40"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"168870","fund_id":"3924","publish_date":"2017-02-09","value_134":"1.000","value_124":null,"value_134_2":"1.000","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.00","id":"0","value_zdfpct":"0.00"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"169023","fund_id":"3924","publish_date":"2017-02-10","value_134":"0.999","value_124":null,"value_134_2":"0.999","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.10","id":"0","value_zdfpct":"-0.10"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"169150","fund_id":"3924","publish_date":"2017-02-13","value_134":"1.001","value_124":null,"value_134_2":"1.001","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.20","id":"0","value_zdfpct":"0.20"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"169333","fund_id":"3924","publish_date":"2017-02-14","value_134":"1.001","value_124":null,"value_134_2":"1.001","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.00","id":"0","value_zdfpct":"0.00"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"169528","fund_id":"3924","publish_date":"2017-02-15","value_134":"0.999","value_124":null,"value_134_2":"0.999","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.20","id":"0","value_zdfpct":"-0.20"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"169681","fund_id":"3924","publish_date":"2017-02-16","value_134":"1.001","value_124":null,"value_134_2":"1.001","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.20","id":"0","value_zdfpct":"0.20"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"169864","fund_id":"3924","publish_date":"2017-02-17","value_134":"0.997","value_124":null,"value_134_2":"0.997","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.40","id":"0","value_zdfpct":"-0.40"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"170119","fund_id":"3924","publish_date":"2017-02-21","value_134":"1.004","value_124":null,"value_134_2":"1.004","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.70","id":"0","value_zdfpct":"0.70"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"170266","fund_id":"3924","publish_date":"2017-02-22","value_134":"1.006","value_124":null,"value_134_2":"1.006","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.20","id":"0","value_zdfpct":"0.20"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"170387","fund_id":"3924","publish_date":"2017-02-23","value_134":"1.001","value_124":null,"value_134_2":"1.001","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.50","id":"0","value_zdfpct":"-0.50"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"170540","fund_id":"3924","publish_date":"2017-02-24","value_134":"0.999","value_124":null,"value_134_2":"0.999","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.20","id":"0","value_zdfpct":"-0.20"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"170733","fund_id":"3924","publish_date":"2017-02-27","value_134":"1.001","value_124":null,"value_134_2":"1.001","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.20","id":"0","value_zdfpct":"0.20"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"170841","fund_id":"3924","publish_date":"2017-02-28","value_134":"1.000","value_124":null,"value_134_2":"1.000","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.10","id":"0","value_zdfpct":"-0.10"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"171000","fund_id":"3924","publish_date":"2017-03-01","value_134":"1.002","value_124":null,"value_134_2":"1.002","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.20","id":"0","value_zdfpct":"0.20"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"171105","fund_id":"3924","publish_date":"2017-03-02","value_134":"1.002","value_124":null,"value_134_2":"1.002","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.00","id":"0","value_zdfpct":"0.00"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"171330","fund_id":"3924","publish_date":"2017-03-03","value_134":"1.003","value_124":null,"value_134_2":"1.003","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.10","id":"0","value_zdfpct":"0.10"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"171451","fund_id":"3924","publish_date":"2017-03-06","value_134":"1.004","value_124":null,"value_134_2":"1.004","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.10","id":"0","value_zdfpct":"0.10"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"171652","fund_id":"3924","publish_date":"2017-03-07","value_134":"1.009","value_124":null,"value_134_2":"1.009","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.50","id":"0","value_zdfpct":"0.50"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"171753","fund_id":"3924","publish_date":"2017-03-08","value_134":"1.010","value_124":null,"value_134_2":"1.010","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.10","id":"0","value_zdfpct":"0.10"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"171997","fund_id":"3924","publish_date":"2017-03-09","value_134":"1.005","value_124":null,"value_134_2":"1.005","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.50","id":"0","value_zdfpct":"-0.50"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"172091","fund_id":"3924","publish_date":"2017-03-10","value_134":"1.014","value_124":null,"value_134_2":"1.014","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.90","id":"0","value_zdfpct":"0.90"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"172215","fund_id":"3924","publish_date":"2017-03-13","value_134":"1.023","value_124":null,"value_134_2":"1.023","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.89","id":"0","value_zdfpct":"0.89"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"172412","fund_id":"3924","publish_date":"2017-03-14","value_134":"1.021","value_124":null,"value_134_2":"1.021","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.20","id":"0","value_zdfpct":"-0.20"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"172602","fund_id":"3924","publish_date":"2017-03-15","value_134":"1.023","value_124":null,"value_134_2":"1.023","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.20","id":"0","value_zdfpct":"0.20"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"172679","fund_id":"3924","publish_date":"2017-03-16","value_134":"1.030","value_124":null,"value_134_2":"1.030","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.68","id":"0","value_zdfpct":"0.68"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"172955","fund_id":"3924","publish_date":"2017-03-17","value_134":"1.022","value_124":null,"value_134_2":"1.022","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.78","id":"0","value_zdfpct":"-0.78"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"173000","fund_id":"3924","publish_date":"2017-03-20","value_134":"1.027","value_124":null,"value_134_2":"1.027","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.49","id":"0","value_zdfpct":"0.49"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"173275","fund_id":"3924","publish_date":"2017-03-21","value_134":"1.033","value_124":null,"value_134_2":"1.033","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.58","id":"0","value_zdfpct":"0.58"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"173328","fund_id":"3924","publish_date":"2017-03-22","value_134":"1.030","value_124":null,"value_134_2":"1.030","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.29","id":"0","value_zdfpct":"-0.29"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"173510","fund_id":"3924","publish_date":"2017-03-23","value_134":"1.034","value_124":null,"value_134_2":"1.034","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.39","id":"0","value_zdfpct":"0.39"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"173735","fund_id":"3924","publish_date":"2017-03-24","value_134":"1.046","value_124":null,"value_134_2":"1.046","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"1.16","id":"0","value_zdfpct":"1.16"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"173928","fund_id":"3924","publish_date":"2017-03-27","value_134":"1.035","value_124":null,"value_134_2":"1.035","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-1.05","id":"0","value_zdfpct":"-1.05"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"174006","fund_id":"3924","publish_date":"2017-03-28","value_134":"1.031","value_124":null,"value_134_2":"1.031","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.39","id":"0","value_zdfpct":"-0.39"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"174162","fund_id":"3924","publish_date":"2017-03-29","value_134":"1.036","value_124":null,"value_134_2":"1.036","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.48","id":"0","value_zdfpct":"0.48"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"174311","fund_id":"3924","publish_date":"2017-03-30","value_134":"1.026","value_124":null,"value_134_2":"1.026","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.97","id":"0","value_zdfpct":"-0.97"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"174571","fund_id":"3924","publish_date":"2017-03-31","value_134":"1.034","value_124":null,"value_134_2":"1.034","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.78","id":"0","value_zdfpct":"0.78"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"174719","fund_id":"3924","publish_date":"2017-04-05","value_134":"1.037","value_124":null,"value_134_2":"1.037","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.29","id":"0","value_zdfpct":"0.29"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"174937","fund_id":"3924","publish_date":"2017-04-06","value_134":"1.034","value_124":null,"value_134_2":"1.034","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.29","id":"0","value_zdfpct":"-0.29"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"174992","fund_id":"3924","publish_date":"2017-04-07","value_134":"1.037","value_124":null,"value_134_2":"1.037","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.29","id":"0","value_zdfpct":"0.29"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"175191","fund_id":"3924","publish_date":"2017-04-10","value_134":"1.028","value_124":null,"value_134_2":"1.028","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.87","id":"0","value_zdfpct":"-0.87"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"175355","fund_id":"3924","publish_date":"2017-04-11","value_134":"1.023","value_124":null,"value_134_2":"1.023","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.49","id":"0","value_zdfpct":"-0.49"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"175581","fund_id":"3924","publish_date":"2017-04-12","value_134":"1.019","value_124":null,"value_134_2":"1.019","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.39","id":"0","value_zdfpct":"-0.39"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"175615","fund_id":"3924","publish_date":"2017-04-13","value_134":"1.017","value_124":null,"value_134_2":"1.017","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.20","id":"0","value_zdfpct":"-0.20"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"176115","fund_id":"3924","publish_date":"2017-04-18","value_134":"1.006","value_124":null,"value_134_2":"1.006","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-1.08","id":"0","value_zdfpct":"-1.08"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"176317","fund_id":"3924","publish_date":"2017-04-19","value_134":"1.006","value_124":null,"value_134_2":"1.006","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.00","id":"0","value_zdfpct":"0.00"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"176520","fund_id":"3924","publish_date":"2017-04-20","value_134":"1.022","value_124":null,"value_134_2":"1.022","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"1.59","id":"0","value_zdfpct":"1.59"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"176668","fund_id":"3924","publish_date":"2017-04-21","value_134":"1.019","value_124":null,"value_134_2":"1.019","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.29","id":"0","value_zdfpct":"-0.29"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"176777","fund_id":"3924","publish_date":"2017-04-24","value_134":"1.012","value_124":null,"value_134_2":"1.012","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.69","id":"0","value_zdfpct":"-0.69"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"177009","fund_id":"3924","publish_date":"2017-04-25","value_134":"1.022","value_124":null,"value_134_2":"1.022","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.99","id":"0","value_zdfpct":"0.99"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"177151","fund_id":"3924","publish_date":"2017-04-26","value_134":"1.025","value_124":null,"value_134_2":"1.025","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.29","id":"0","value_zdfpct":"0.29"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"177360","fund_id":"3924","publish_date":"2017-04-27","value_134":"1.031","value_124":null,"value_134_2":"1.031","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.59","id":"0","value_zdfpct":"0.59"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"177590","fund_id":"3924","publish_date":"2017-04-28","value_134":"1.031","value_124":null,"value_134_2":"1.031","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.00","id":"0","value_zdfpct":"0.00"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"177674","fund_id":"3924","publish_date":"2017-05-02","value_134":"1.033","value_124":null,"value_134_2":"1.033","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.19","id":"0","value_zdfpct":"0.19"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"177991","fund_id":"3924","publish_date":"2017-05-04","value_134":"1.022","value_124":null,"value_134_2":"1.022","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-1.06","id":"0","value_zdfpct":"-1.06"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"178259","fund_id":"3924","publish_date":"2017-05-05","value_134":"1.019","value_124":null,"value_134_2":"1.019","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.29","id":"0","value_zdfpct":"-0.29"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"178351","fund_id":"3924","publish_date":"2017-05-08","value_134":"1.016","value_124":null,"value_134_2":"1.016","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.29","id":"0","value_zdfpct":"-0.29"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"178572","fund_id":"3924","publish_date":"2017-05-09","value_134":"1.030","value_124":null,"value_134_2":"1.030","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"1.38","id":"0","value_zdfpct":"1.38"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"178602","fund_id":"3924","publish_date":"2017-05-10","value_134":"1.037","value_124":null,"value_134_2":"1.037","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.68","id":"0","value_zdfpct":"0.68"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"178843","fund_id":"3924","publish_date":"2017-05-11","value_134":"1.041","value_124":null,"value_134_2":"1.041","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.39","id":"0","value_zdfpct":"0.39"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"179050","fund_id":"3924","publish_date":"2017-05-12","value_134":"1.036","value_124":null,"value_134_2":"1.036","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.48","id":"0","value_zdfpct":"-0.48"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"179253","fund_id":"3924","publish_date":"2017-05-15","value_134":"1.045","value_124":null,"value_134_2":"1.045","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.87","id":"0","value_zdfpct":"0.87"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"179385","fund_id":"3924","publish_date":"2017-05-16","value_134":"1.070","value_124":null,"value_134_2":"1.070","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"2.39","id":"0","value_zdfpct":"2.39"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"179490","fund_id":"3924","publish_date":"2017-05-17","value_134":"1.056","value_124":null,"value_134_2":"1.056","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-1.31","id":"0","value_zdfpct":"-1.31"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"179643","fund_id":"3924","publish_date":"2017-05-18","value_134":"1.048","value_124":null,"value_134_2":"1.048","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.76","id":"0","value_zdfpct":"-0.76"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"179936","fund_id":"3924","publish_date":"2017-05-19","value_134":"1.047","value_124":null,"value_134_2":"1.047","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.10","id":"0","value_zdfpct":"-0.10"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"180087","fund_id":"3924","publish_date":"2017-05-22","value_134":"1.050","value_124":null,"value_134_2":"1.050","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.29","id":"0","value_zdfpct":"0.29"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"180143","fund_id":"3924","publish_date":"2017-05-23","value_134":"1.043","value_124":null,"value_134_2":"1.043","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.67","id":"0","value_zdfpct":"-0.67"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"180406","fund_id":"3924","publish_date":"2017-05-24","value_134":"1.041","value_124":null,"value_134_2":"1.041","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.19","id":"0","value_zdfpct":"-0.19"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"180456","fund_id":"3924","publish_date":"2017-05-25","value_134":"1.037","value_124":null,"value_134_2":"1.037","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.38","id":"0","value_zdfpct":"-0.38"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"180711","fund_id":"3924","publish_date":"2017-05-26","value_134":"1.036","value_124":null,"value_134_2":"1.036","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.10","id":"0","value_zdfpct":"-0.10"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"180833","fund_id":"3924","publish_date":"2017-05-31","value_134":"1.031","value_124":null,"value_134_2":"1.031","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.48","id":"0","value_zdfpct":"-0.48"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"181012","fund_id":"3924","publish_date":"2017-06-01","value_134":"1.027","value_124":null,"value_134_2":"1.027","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.39","id":"0","value_zdfpct":"-0.39"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"181263","fund_id":"3924","publish_date":"2017-06-02","value_134":"1.033","value_124":null,"value_134_2":"1.033","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.58","id":"0","value_zdfpct":"0.58"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"181404","fund_id":"3924","publish_date":"2017-06-05","value_134":"1.039","value_124":null,"value_134_2":"1.039","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.58","id":"0","value_zdfpct":"0.58"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"181566","fund_id":"3924","publish_date":"2017-06-06","value_134":"1.043","value_124":null,"value_134_2":"1.043","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.38","id":"0","value_zdfpct":"0.38"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"181730","fund_id":"3924","publish_date":"2017-06-07","value_134":"1.058","value_124":null,"value_134_2":"1.058","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"1.44","id":"0","value_zdfpct":"1.44"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"181862","fund_id":"3924","publish_date":"2017-06-08","value_134":"1.070","value_124":null,"value_134_2":"1.070","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"1.13","id":"0","value_zdfpct":"1.13"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"182125","fund_id":"3924","publish_date":"2017-06-09","value_134":"1.069","value_124":null,"value_134_2":"1.069","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.09","id":"0","value_zdfpct":"-0.09"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"182214","fund_id":"3924","publish_date":"2017-06-12","value_134":"1.043","value_124":null,"value_134_2":"1.043","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-2.43","id":"0","value_zdfpct":"-2.43"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"182478","fund_id":"3924","publish_date":"2017-06-13","value_134":"1.051","value_124":null,"value_134_2":"1.051","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.77","id":"0","value_zdfpct":"0.77"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"182558","fund_id":"3924","publish_date":"2017-06-14","value_134":"1.045","value_124":null,"value_134_2":"1.045","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.57","id":"0","value_zdfpct":"-0.57"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"182737","fund_id":"3924","publish_date":"2017-06-15","value_134":"1.044","value_124":null,"value_134_2":"1.044","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.10","id":"0","value_zdfpct":"-0.10"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"182878","fund_id":"3924","publish_date":"2017-06-16","value_134":"1.051","value_124":null,"value_134_2":"1.051","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.67","id":"0","value_zdfpct":"0.67"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"183088","fund_id":"3924","publish_date":"2017-06-19","value_134":"1.061","value_124":null,"value_134_2":"1.061","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.95","id":"0","value_zdfpct":"0.95"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"183262","fund_id":"3924","publish_date":"2017-06-20","value_134":"1.063","value_124":null,"value_134_2":"1.063","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.19","id":"0","value_zdfpct":"0.19"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"183462","fund_id":"3924","publish_date":"2017-06-21","value_134":"1.080","value_124":null,"value_134_2":"1.080","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"1.60","id":"0","value_zdfpct":"1.60"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"183623","fund_id":"3924","publish_date":"2017-06-22","value_134":"1.070","value_124":null,"value_134_2":"1.070","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.93","id":"0","value_zdfpct":"-0.93"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"183768","fund_id":"3924","publish_date":"2017-06-23","value_134":"1.081","value_124":null,"value_134_2":"1.081","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"1.03","id":"0","value_zdfpct":"1.03"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"183978","fund_id":"3924","publish_date":"2017-06-26","value_134":"1.087","value_124":null,"value_134_2":"1.087","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.56","id":"0","value_zdfpct":"0.56"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"184135","fund_id":"3924","publish_date":"2017-06-27","value_134":"1.081","value_124":null,"value_134_2":"1.081","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.55","id":"0","value_zdfpct":"-0.55"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"184223","fund_id":"3924","publish_date":"2017-06-28","value_134":"1.063","value_124":null,"value_134_2":"1.063","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-1.67","id":"0","value_zdfpct":"-1.67"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"184422","fund_id":"3924","publish_date":"2017-06-29","value_134":"1.066","value_124":null,"value_134_2":"1.066","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.28","id":"0","value_zdfpct":"0.28"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"184576","fund_id":"3924","publish_date":"2017-06-30","value_134":"1.063","value_124":"197508511.31","value_134_2":"1.063","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.28","id":"0","value_zdfpct":"-0.28"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"184839","fund_id":"3924","publish_date":"2017-07-03","value_134":"1.058","value_124":null,"value_134_2":"1.058","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.47","id":"0","value_zdfpct":"-0.47"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"185024","fund_id":"3924","publish_date":"2017-07-05","value_134":"1.071","value_124":null,"value_134_2":"1.071","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"1.23","id":"0","value_zdfpct":"1.23"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"185226","fund_id":"3924","publish_date":"2017-07-06","value_134":"1.075","value_124":null,"value_134_2":"1.075","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.37","id":"0","value_zdfpct":"0.37"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"185504","fund_id":"3924","publish_date":"2017-07-07","value_134":"1.075","value_124":null,"value_134_2":"1.075","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.00","id":"0","value_zdfpct":"0.00"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"185585","fund_id":"3924","publish_date":"2017-07-10","value_134":"1.076","value_124":null,"value_134_2":"1.076","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.09","id":"0","value_zdfpct":"0.09"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"185751","fund_id":"3924","publish_date":"2017-07-11","value_134":"1.082","value_124":null,"value_134_2":"1.082","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.56","id":"0","value_zdfpct":"0.56"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"185950","fund_id":"3924","publish_date":"2017-07-12","value_134":"1.092","value_124":null,"value_134_2":"1.092","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.92","id":"0","value_zdfpct":"0.92"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"186099","fund_id":"3924","publish_date":"2017-07-13","value_134":"1.096","value_124":null,"value_134_2":"1.096","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.37","id":"0","value_zdfpct":"0.37"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"186391","fund_id":"3924","publish_date":"2017-07-14","value_134":"1.095","value_124":null,"value_134_2":"1.095","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.09","id":"0","value_zdfpct":"-0.09"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"186445","fund_id":"3924","publish_date":"2017-07-17","value_134":"1.090","value_124":null,"value_134_2":"1.090","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.46","id":"0","value_zdfpct":"-0.46"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"186668","fund_id":"3924","publish_date":"2017-07-18","value_134":"1.098","value_124":null,"value_134_2":"1.098","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.73","id":"0","value_zdfpct":"0.73"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"186801","fund_id":"3924","publish_date":"2017-07-19","value_134":"1.119","value_124":null,"value_134_2":"1.119","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"1.91","id":"0","value_zdfpct":"1.91"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"186919","fund_id":"3924","publish_date":"2017-07-20","value_134":"1.124","value_124":null,"value_134_2":"1.124","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.45","id":"0","value_zdfpct":"0.45"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"187243","fund_id":"3924","publish_date":"2017-07-21","value_134":"1.125","value_124":null,"value_134_2":"1.125","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.09","id":"0","value_zdfpct":"0.09"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"187432","fund_id":"3924","publish_date":"2017-07-24","value_134":"1.140","value_124":null,"value_134_2":"1.140","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"1.33","id":"0","value_zdfpct":"1.33"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"187531","fund_id":"3924","publish_date":"2017-07-25","value_134":"1.132","value_124":null,"value_134_2":"1.132","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.70","id":"0","value_zdfpct":"-0.70"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"187630","fund_id":"3924","publish_date":"2017-07-26","value_134":"1.117","value_124":null,"value_134_2":"1.117","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-1.33","id":"0","value_zdfpct":"-1.33"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"187829","fund_id":"3924","publish_date":"2017-07-27","value_134":"1.119","value_124":null,"value_134_2":"1.119","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.18","id":"0","value_zdfpct":"0.18"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"188059","fund_id":"3924","publish_date":"2017-07-28","value_134":"1.118","value_124":null,"value_134_2":"1.118","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.09","id":"0","value_zdfpct":"-0.09"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"188284","fund_id":"3924","publish_date":"2017-07-31","value_134":"1.118","value_124":null,"value_134_2":"1.118","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.00","id":"0","value_zdfpct":"0.00"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"188462","fund_id":"3924","publish_date":"2017-08-01","value_134":"1.111","value_124":null,"value_134_2":"1.111","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.63","id":"0","value_zdfpct":"-0.63"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"188568","fund_id":"3924","publish_date":"2017-08-02","value_134":"1.109","value_124":null,"value_134_2":"1.109","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.18","id":"0","value_zdfpct":"-0.18"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"188786","fund_id":"3924","publish_date":"2017-08-03","value_134":"1.096","value_124":null,"value_134_2":"1.096","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-1.17","id":"0","value_zdfpct":"-1.17"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"189006","fund_id":"3924","publish_date":"2017-08-04","value_134":"1.095","value_124":null,"value_134_2":"1.095","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.09","id":"0","value_zdfpct":"-0.09"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"189191","fund_id":"3924","publish_date":"2017-08-07","value_134":"1.106","value_124":null,"value_134_2":"1.106","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"1.00","id":"0","value_zdfpct":"1.00"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"189344","fund_id":"3924","publish_date":"2017-08-08","value_134":"1.118","value_124":null,"value_134_2":"1.118","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"1.08","id":"0","value_zdfpct":"1.08"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"189389","fund_id":"3924","publish_date":"2017-08-09","value_134":"1.115","value_124":null,"value_134_2":"1.115","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.27","id":"0","value_zdfpct":"-0.27"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"189589","fund_id":"3924","publish_date":"2017-08-10","value_134":"1.098","value_124":null,"value_134_2":"1.098","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-1.52","id":"0","value_zdfpct":"-1.52"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"189808","fund_id":"3924","publish_date":"2017-08-11","value_134":"1.081","value_124":null,"value_134_2":"1.081","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-1.55","id":"0","value_zdfpct":"-1.55"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"190046","fund_id":"3924","publish_date":"2017-08-14","value_134":"1.104","value_124":null,"value_134_2":"1.104","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"2.13","id":"0","value_zdfpct":"2.13"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"190186","fund_id":"3924","publish_date":"2017-08-15","value_134":"1.102","value_124":null,"value_134_2":"1.102","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.18","id":"0","value_zdfpct":"-0.18"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"190340","fund_id":"3924","publish_date":"2017-08-16","value_134":"1.122","value_124":null,"value_134_2":"1.122","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"1.81","id":"0","value_zdfpct":"1.81"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"190408","fund_id":"3924","publish_date":"2017-08-17","value_134":"1.109","value_124":null,"value_134_2":"1.109","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-1.16","id":"0","value_zdfpct":"-1.16"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"190708","fund_id":"3924","publish_date":"2017-08-18","value_134":"1.107","value_124":null,"value_134_2":"1.107","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.18","id":"0","value_zdfpct":"-0.18"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"190809","fund_id":"3924","publish_date":"2017-08-21","value_134":"1.115","value_124":null,"value_134_2":"1.115","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.72","id":"0","value_zdfpct":"0.72"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"191020","fund_id":"3924","publish_date":"2017-08-22","value_134":"1.090","value_124":null,"value_134_2":"1.090","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-2.24","id":"0","value_zdfpct":"-2.24"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"191129","fund_id":"3924","publish_date":"2017-08-23","value_134":"1.098","value_124":null,"value_134_2":"1.098","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.73","id":"0","value_zdfpct":"0.73"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"191287","fund_id":"3924","publish_date":"2017-08-24","value_134":"1.101","value_124":null,"value_134_2":"1.101","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.27","id":"0","value_zdfpct":"0.27"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"191649","fund_id":"3924","publish_date":"2017-08-25","value_134":"1.089","value_124":null,"value_134_2":"1.089","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-1.09","id":"0","value_zdfpct":"-1.09"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"191794","fund_id":"3924","publish_date":"2017-08-28","value_134":"1.077","value_124":null,"value_134_2":"1.077","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-1.10","id":"0","value_zdfpct":"-1.10"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"191915","fund_id":"3924","publish_date":"2017-08-29","value_134":"1.077","value_124":null,"value_134_2":"1.077","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.00","id":"0","value_zdfpct":"0.00"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"191998","fund_id":"3924","publish_date":"2017-08-30","value_134":"1.085","value_124":null,"value_134_2":"1.085","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.74","id":"0","value_zdfpct":"0.74"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"192218","fund_id":"3924","publish_date":"2017-08-31","value_134":"1.092","value_124":null,"value_134_2":"1.092","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.65","id":"0","value_zdfpct":"0.65"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"192376","fund_id":"3924","publish_date":"2017-09-01","value_134":"1.104","value_124":null,"value_134_2":"1.104","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"1.10","id":"0","value_zdfpct":"1.10"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"192718","fund_id":"3924","publish_date":"2017-09-05","value_134":"1.104","value_124":null,"value_134_2":"1.104","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.00","id":"0","value_zdfpct":"0.00"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"192920","fund_id":"3924","publish_date":"2017-09-06","value_134":"1.105","value_124":null,"value_134_2":"1.105","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.09","id":"0","value_zdfpct":"0.09"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"193134","fund_id":"3924","publish_date":"2017-09-07","value_134":"1.120","value_124":null,"value_134_2":"1.120","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"1.36","id":"0","value_zdfpct":"1.36"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"193272","fund_id":"3924","publish_date":"2017-09-08","value_134":"1.114","value_124":null,"value_134_2":"1.114","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.54","id":"0","value_zdfpct":"-0.54"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"193469","fund_id":"3924","publish_date":"2017-09-11","value_134":"1.128","value_124":null,"value_134_2":"1.128","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"1.26","id":"0","value_zdfpct":"1.26"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"193585","fund_id":"3924","publish_date":"2017-09-12","value_134":"1.146","value_124":null,"value_134_2":"1.146","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"1.60","id":"0","value_zdfpct":"1.60"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"193784","fund_id":"3924","publish_date":"2017-09-13","value_134":"1.159","value_124":null,"value_134_2":"1.159","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"1.13","id":"0","value_zdfpct":"1.13"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"193915","fund_id":"3924","publish_date":"2017-09-14","value_134":"1.152","value_124":null,"value_134_2":"1.152","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"-0.60","id":"0","value_zdfpct":"-0.60"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"194123","fund_id":"3924","publish_date":"2017-09-15","value_134":"1.153","value_124":null,"value_134_2":"1.153","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"0.09","id":"0","value_zdfpct":"0.09"},{"fund_type":"1","fund_name":"华夏移动互联混合（QDII）","code":"002891","administrater":null,"fund_value_id":"194307","fund_id":"3924","publish_date":"2017-09-18","value_134":"1.175","value_124":null,"value_134_2":"1.175","value_2_1":null,"value_2_2":null,"value_2_3":null,"value_2_4":null,"value_2_5":null,"value_3_1":null,"value_4_1":null,"value_u_d":null,"holiday_flag":null,"value_zdf":"1.91","id":"0","value_zdfpct":"1.91"}],"totalElements":161}}

let width = window.screen.width 

/*公募详情*/
class PublicOffering extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingFlag:true,
    }
  }
  componentWillMount() {
  	let { dispatch } = this.props;
  	let funcodeVue = this.props.location.state.fundCode ? this.props.location.state.fundCode : "000021";
  	dispatch(getPublicProductDetil(funcodeVue,this.handleCallback.bind(this),this));
  }
  handleCallback(data){

  }
  componentDidMount(){
    let { dispatch } = this.props;
  }
  componentWillUnmount() {
    let data= {
      PublicDetilAllocation:[],
      PublicDetilAsset:[],
      PublicDetilBaseInfo:[{
        managers:"",
      }],
      PublicDetilBond:[],
      PublicDetilInfo:[
        {discount_rate:"",dtstatus:"",
        fundcode:"",fundenddate:null,
        fundfullname:"",fundmessage:"",
        fundname:"",fundstartdate:"",
        fundtype:"",fundvalue:"",
        isshow:null,leijijingzhi:"",numcolor:"",
        publish_date:"",qirinianhua:null,
        qrnhcolor:"",rate:"",sgstatus:"",
        show_discount_rate:"",
        tradedt:"",tradesg:"",wanfenshouyi:null,
        year3grade:"",year5grade:"",zhangdiefu:"",
        tradedt:"",
      }],
      PublicDetilManager:[],
      PublicDetilProfit:[{
        fundcode:"",fundname:"",fundtype:""
        ,m1:"",m3:"",m6:"",sumdate:"",
        totalnavchgrate:null,w1:"",y1:"",y2:null,y3:"",y4:null,
        y5:"",yearnavchgrate:null
      }],
      PublicDetilRate:[],
      PublicDetilStock:[]
    }
    this.props.dispatch(fundPublicDetil(data))
  }
  goBack(){
    hashHistory.goBack();
  }
  render(){
  	let { fundPublicProductDetil,fundHistoty,AddZxFlag, payLoading } = this.props;
  	console.log(fundPublicProductDetil,"------------")
  	var dataInfo = fundPublicProductDetil.PublicDetilInfo[0];
    let title = dataInfo.fundname.length > 1 ? dataInfo.fundname + "(" + dataInfo.fundcode +")" : "";
    document.getElementsByTagName('title')[0].innerHTML = title;
    console.log(title,"fundcodefundcodefundcode")
    let fundtype = dataInfo.fundtype;
    let touzFx = getFx(fundtype);
    let funcodeVue = this.props.location.state.fundCode;
    console.log(funcodeVue,"funcodeVuefuncodeVuefuncodeVuefuncodeVue")

    return(
      <div className="container">
      	<ModalSelect/>
        <NavigatorMain>
          <div className="header black">
            <div ><span className="headerLeftBtn" onClick={ ()=> this.goBack() }></span></div>
            <div > { title } </div>
            <div ></div>    
          </div>
        </NavigatorMain>
        <div className='content'>
          <TopMain data ={ dataInfo } />

          <div style={{ WebkitFlex:1, height:10 }}></div>

          <IncomeShowTab touzFx={ touzFx } dispatch = { this.props.dispatch } funcodeVue = { funcodeVue }/>

          <div style={{ WebkitFlex:1, height:10 }}></div>

          <ListNumber data={ fundPublicProductDetil.PublicDetilProfit[0] } />

          <div style={{ WebkitFlex:1, height:10 }}></div>

          <FundInfoList data = {fundPublicProductDetil}  touzFx = { touzFx } />

          <div style={{ WebkitFlex:1, height:10 }}></div>

        </div>
        
        {/*底部定投自选购买组件*/}
        <div style={{ height:44 }}></div>
        <BottomPart fundPublicProductDetil={fundPublicProductDetil}  optional = { AddZxFlag } dispatch={ this.props.dispatch } dataInfo={dataInfo} />
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
	fundPublicProductDetil:state.fundPublicProductDetil,
	fundHistoty:state.fundHistoty,
	AddZxFlag:state.AddZxFlag
  }
}

export default connect(mapStateToProps)(PublicOffering);

class TopMain extends Component{
  constructor(props) {
    super(props);
    this.state = {
    }
  }
  render(){
  	let {data} = this.props;
    let fundtype = data.fundtype;
    let touzFx = getFx(fundtype);
    let year3grade = data.year3grade;
    return(
      <div>
      	{
      		touzFx !== "低" ? 
      		<div style={{ height:84,WebkitFlexDirection:'row', display: "-webkit-flex", paddingTop:20, backgroundColor:'#FFF' }}>
	    		<div style={{ WebkitFlex:1, textAlign:'center'}}>
		            <div style={{ fontSize:'0.44rem',color:"#fb615b", height:21 }}>
		            	{ data.fundvalue }
		            </div>
		            <div style={{ fontSize:'0.24rem',color:"#5b6370",marginTop:2 }}>最新净值(元)</div>
		            <div style={{ fontSize:'0.2rem',color:"rgb(152,160,172)",marginTop:2 }}>
		            	{ data.publish_date }
		            </div>
		        </div>

	         	<div style={{ WebkitFlex:1, textAlign:'center' }}>
		            <div style={{ fontSize:'0.44rem', color:data.zhangdiefu >=0 ? "#fb615b" : "#7fdd81", height:21 }}>
		            	{
		            		data.zhangdiefu != null && data.zhangdiefu !== "" ? data.zhangdiefu +  "%" : "--"
		            	}
		            </div>
		            <div style={{ fontSize:'0.24rem', color:"#5b6370", marginTop:2 }}>日涨跌幅</div>
		        </div>

	            <div style={{ WebkitFlex:1,textAlign:'center' }}>
	            	<div style={{ fontSize:'0.44rem', color:'#fb615b', height:21 }}>{touzFx}</div>
	             	<div style={{ fontSize:'0.24rem', color:"#5b6370", marginTop:2 }}>投资风险</div>
		        </div> 
	        </div> : 
	        <div style={{ height:84,WebkitFlexDirection:'row',display: "-webkit-flex",paddingTop:20,backgroundColor:'#FFF' }}>
	    		<div style={{ WebkitFlex:1, textAlign:'center'}}>
		            <div style={{ fontSize:'0.44rem',color:"#fb615b", height:21  }}>
		            	{ data.wanfenshouyi } 
		            </div>
		            <div style={{ fontSize:'0.24rem',color:"#5b6370",marginTop:2 }}>万分收益(元)</div>
		            <div style={{ fontSize:'0.2rem',color:"rgb(152,160,172)",marginTop:2 }}>{ data.publish_date }</div>
		        </div>

	         	<div style={{ WebkitFlex:1, textAlign:'center' }}>
		            <div style={{ fontSize:'0.44rem', color:"#7fdd81", height:21 }}>{ data.qirinianhua }</div>
		            <div style={{ fontSize:'0.24rem', color:"#5b6370", marginTop:2 }}>七日年化</div>
		        </div>

	            <div style={{ WebkitFlex:1,textAlign:'center' }}>
	            	<div style={{ fontSize:'0.44rem', color:'#fb615b', height:21 }}>{touzFx}</div>
	             	<div style={{ fontSize:'0.24rem', color:"#5b6370", marginTop:2 }}>投资风险</div>
		        </div>
	        </div>
      	}
       
        <div style={{ height:43, display: "-webkit-flex", WebkitFlexDirection:'row', backgroundColor:'#FFF', borderTop:"solid #ebeef0 1px" }}>
          <div style={{ WebkitFlex:1, display: "-webkit-flex", WebkitAlignItems:'center', paddingLeft:25, fontSize:'0.28rem' }}>{ data.fundtype }</div>
          <div style={{ WebkitFlex:1, display: "-webkit-flex", WebkitAlignItems:'center', WebkitJustifyContent:'flex-end', paddingRight:13 }}>
            <span style={{fontSize:'0.28rem', marginRight:6 }}>银河评级</span>{ returnStar(year3grade) }
           </div>
        </div>

      </div>
    )
  }
}

function returnStar(year3grade){
	let stars = [];
    let endStar = 5 - year3grade;
    if(endStar === 5){
	    stars.push(
	        <span style={{ fontSize:'0.28rem', color:'#5b6370' }}>暂无</span>
	      )
    }else{
      for(let i=0; i<year3grade; i++){
        stars.push(
          <span className="stars2" key={ i + 11 } ></span>
        )
      }
      for(let i=0; i<endStar; i++){
        stars.push(
          <span className="stars1" key={ i + 12 } ></span>
        )
      }
    }
    return stars;
}

class BottomPart extends Component{
  constructor(props) {
    super(props);
    this.state = {
    }
  }
  handleOptional(){
    console.log(this.props.dataInfo.fundcode)
    let data = {
      fundcode:this.props.dataInfo.fundcode,
    }
    let callBack = this.props.callBack;
    console.log( this.props.optional )
    if(this.props.optional == "0"){
      this.props.dispatch(reateOptional(data));
    }else{
      this.props.dispatch(deleteOptional(data));
    }
  }
  goInvestPlan(){
  	let dataInfo = this.props.dataInfo;
  	var paramss = {
      fundCode:dataInfo.fundcode,
      businessType:this.props.fundPublicProductDetil.businessType,
      productType:'G',
      titleHeader:'新建定投计划',
      currentNav:dataInfo.fundvalue,
      currentNavDate:dataInfo.publish_date,
      item:{
        shareClassName:this.props.fundPublicProductDetil.fundShareClassName
      },
      fundType:dataInfo.fundtype,
      wanfenshouyi:dataInfo.wanfenshouyi ? dataInfo.wanfenshouyi : "",
      fundName:dataInfo.fundname,
    }
    getPayAll(window.history.length,paramss,hashHistory,'FixedInvestment')
  }
  goPay(){
    let dataInfo = this.props.dataInfo;
  	var paramss = {
  		fundName:dataInfo.fundname,
        fundCode:dataInfo.fundcode,
        businessType:this.props.fundPublicProductDetil.businessType,
        productType:'G',
        fundType:dataInfo.fundtype,
        wanfenshouyi:dataInfo.wanfenshouyi
    }
  	getPayAll(window.history.length,paramss, hashHistory, 'Payment')
  }
  render(){
    let state = true;
    let zxFlag = this.props.optional;
    console.log(this.props)
    return(
      <div style={{ position:"fixed", bottom:0, width:"100%", height:40 }}>
      <div style={{ height:40, display: "-webkit-flex", WebkitFlexDirection:'row', }}>
          {
            state?
            <div onClick={()=>this.goInvestPlan()} style={{ WebkitFlex:2,borderTop:'#e1e3e6 solid 1px', borderRight:'#e1e3e6 solid 1px',display: "-webkit-flex", WebkitAlignItems:'center', WebkitFlexDirection:'column', background:"#FFF" }}>
              <div style={{display: "-webkit-flex", height:24,WebkitAlignItems:'center'}} >
                <span className="dtIcon"></span>
              </div>
              <div style={{ fontSize:12,color:'rgb(90,99,112)'}}>定投</div>
            </div> : null
          }
          {
          	zxFlag == "0" || zxFlag == 0 ? 
          	<div style={{ WebkitFlex:2,borderTop:'#e1e3e6 solid 1px',display: "-webkit-flex", WebkitAlignItems:'center', WebkitFlexDirection:'column', background:"#FFF" }} onClick = { goLogin.bind(this,this.handleOptional.bind(this),window.history.length) } >
	            <div style={{display: "-webkit-flex", height:24,WebkitAlignItems:'center'}} >
	              <span className="zxIcon"></span>
	            </div>
	            <div style={{ fontSize:12,color:'rgb(90,99,112)' }}>加自选</div>
	        </div> : 
	        <div style={{ WebkitFlex:2,borderTop:'#e1e3e6 solid 1px',display: "-webkit-flex", WebkitAlignItems:'center', WebkitFlexDirection:'column', background:"#FFF" }} onClick = { goLogin.bind(this,this.handleOptional.bind(this),window.history.length) } >
	            <div style={{display: "-webkit-flex", height:24,WebkitAlignItems:'center'}} >
	              <span className="zxIcon2"></span>
	            </div>
	            <div style={{ fontSize:12,color:'rgb(90,99,112)' }}>取消自选</div>
	        </div>
          }
          {
          	this.props.fundPublicProductDetil.businessType === "T022" ||  this.props.fundPublicProductDetil.businessType === "T020"?
          	<div onClick={()=>this.goPay()} style={{ WebkitFlex:state ? 6 : 8, backgroundColor:"#fa063a", color:'#FFF', fontSize:'0.3rem',display: "-webkit-flex", WebkitJustifyContent:'center', WebkitAlignItems:'center' }}>
	            <span>申购</span>
	        </div>:<div  style={{ WebkitFlex:state ? 6 : 8, backgroundColor:"#afb0b3", color:'#FFF', fontSize:'0.3rem',display: "-webkit-flex", WebkitJustifyContent:'center', WebkitAlignItems:'center' }}>
	            <span>申购</span>
	        </div>
          }
          
      </div>
      </div>
    )
  }
}


class IncomeShowTab extends Component{
  constructor(props) {
    super(props);
    this.state = {
    	txt:"单位净值"
    }
  }
  handerClick(txt){
    this.setState({
      txt:txt
    })
  }
  goHistoryRate(){
  	hashHistory.push({
        pathname:'/HistoryRate',
        state:{
          
        }
    })
  }
  render(){
    let state = true; 
    let { txt } = this.state;
    let { touzFx, funcodeVue } = this.props;
    return(
      <div style={{ height:424, background:'#FFF'}}>
        <div style={{ height:48, border:"1px solid #ebeef0",paddingLeft:45, paddingRight:45, WebkitFlex:1 }}>
          <div style={{ WebkitFlexDirection:'row', display: "-webkit-flex", height:48 }}>
            <div className={ txt === "单位净值" ? "TabClick2" : "TabClick1"  } onClick={()=>{ this.handerClick("单位净值") }} ><span>单位净值</span></div>
            <div className={ txt === "累计净值" ? "TabClick2" : "TabClick1"  } onClick={()=>{ this.handerClick("累计净值") }} > <span>累计净值</span></div>
          </div>
        </div>
        {	
        	touzFx !== "低" ? 
        	(txt === "单位净值" ? <TabLineComponent dispatch = { this.props.dispatch } fundvalue ={ funcodeVue } /> : <TabLineComponentTwo dispatch = { this.props.dispatch } fundvalue ={ funcodeVue } /> )
        	:
        	( txt === "累计净值" ? <TabLineComponentH dispatch = { this.props.dispatch } fundvalue ={ funcodeVue } /> : <TabLineComponentHTwo dispatch = { this.props.dispatch } fundvalue ={ funcodeVue } /> )
        }
        <div style={{ height:44, display: "-webkit-flex", border:"1px solid #ebeef0", WebkitJustifyContent:'center', WebkitAlignItems:'center' }} onClick={()=>{ this.goHistoryRate(funcodeVue)  }} >
          <div style={{ fontSize:'0.28rem', color:'#3A3E47' }}>查看历史净值</div>
        </div>

      </div>
    )
  }
}

class ListNumber extends Component{
  constructor(props) {
    super(props);
    this.state = {

    }
  }
  render(){
  	let { data } = this.props;
    let state = true; 
    return(
      <div style={{ height:205, background:'#FFF', paddingTop:12 }}>
        <div className="numberList">
          <div className="numberListTitle" ><span>时间区间</span></div>
          <div className="numberListTitle" ><span>涨跌幅</span></div>
        </div>
        <div className="numberList2">
          <div className="numberListLi" ><span>近一个月</span></div>
          <div className="numberListLi" ><span>{ data.m1 != null ? Util.fomatFloat(data.m1) + "%" : "-" }</span></div>
        </div>

        <div className="numberList">
          <div className="numberListLi" ><span>近三个月</span></div>
          <div className="numberListLi" ><span>{ data.m3 != null ? Util.fomatFloat(data.m3) + "%" : "-" }</span></div>
        </div>

        <div className="numberList2">
          <div className="numberListLi" ><span>近一年</span></div>
          <div className="numberListLi" ><span> { data.y1 != null ? Util.fomatFloat(data.y1) + "%" : "-" } </span></div>
        </div>

        <div className="numberList">
          <div className="numberListLi" ><span>成立以来</span></div>
          <div className="numberListLi" ><span> { data.totalnavchgrate != null ? Util.fomatFloat(data.totalnavchgrate) + "%" : "-" } </span></div>
        </div>

      </div>
    )
  }
}

class FundInfoList extends Component{
  constructor(props) {
    super(props);
    this.state = {

    }
  }
  pushPublicDetilBaseInfo(){
  	hashHistory.push({
      pathname: '/FundGk',
      state:{data:this.props.data.PublicDetilBaseInfo[0], minAmount:this.props.data.minAmount },
      query: {code:''}
    });
  }
  pushManagersList(){
    let managers = this.props.data.PublicDetilManager;
    if(managers.length > 1){
    	hashHistory.push({
	      pathname: '/ManagersList',
	      state:{data:managers, touzFx:this.props.touzFx },
	      query: {code:''}
	    });
    }else{
    	hashHistory.push({
	      pathname: '/ManagersDetail',
	      state:{data:managers[0], touzFx:this.props.touzFx },
	      query: {code:''}
	    });
    }

  }
  pushRate(){
  	let data = this.props.data;
    hashHistory.push({
      pathname: '/Rate',
      state:{data:data.PublicDetilRate, touzFx:this.props.touzFx },
    });
  }
  pushPositionSituation(){
  	let data = this.props.data;
    hashHistory.push({
      pathname: '/PositionSituation',
      state:{data:data, touzFx:this.props.touzFx },
    });
  }
  render(){
  	let { data } = this.props;
  	let dataShow = data.PublicDetilInfo[0];
  	let rateShow = "";
  	let man = "";
    if(dataShow.show_discount_rate == "Y"){
      rateShow = "最低" + dataShow.discount_rate
    }
    for(let i=0 ;i<data.PublicDetilManager.length; i++){
      man += " "+data.PublicDetilManager[i].name
    }

    let state = true;

    return(
      <div style={{ background:'#FFF' }}>
        <div className="listStyle" onClick={ ()=>{ this.pushPublicDetilBaseInfo() } }>
          <div><span>基金概况</span></div>
          <div><span> { dataShow.sgstatus } </span><span className="arrowRight"></span></div>
        </div>

        <div className="listStyle" onClick={ ()=>{ this.pushManagersList() } } >
          <div><span>基金经理</span></div>
          <div><span> { man } </span><span className="arrowRight"></span></div>
        </div>

        <div className="listStyle" onClick={ ()=>{ this.pushRate() } } >
          <div><span>费率介绍</span></div>
          <div><span>最低0.6%</span><span className="arrowRight"></span></div>
        </div>

        <div className="listStyle" onClick={ ()=>{ this.pushPositionSituation() } }>
          <div><span>持仓情况</span></div>
          <div><span className="arrowRight"></span></div>
        </div>

      </div>
    )
  }
}






class LineComponent extends Component{
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
     // var myChart = echarts.init(document.getElementById('SuperLine'));
     //  // 绘制图表
     //  let dataArr = [];
     //  this.props.data2 ? this.props.data2.map(function(item){
     //    dataArr.push(Util.newToFixed(item*100))
     //  }): null
     //  myChart.setOption(returnLineOption(this.props.data1,dataArr));
  }
  componentWillUpdate(nextProps, nextState) {

  }
  componentDidUpdate(){
      var myChart = echarts.init(document.getElementById('PublicOfferLine'));
      // 绘制图表
      myChart.clear();
      myChart.setOption(lineOption(this.props.data1,this.props.data2));
  }
  render(){
    return(
      <div id="PublicOfferLine" style={{ width:"100%", height:300, paddingLeft:'8px' }}></div>
    );
  }
}



/*收益表现下的折线图*/
/*单位净值*/
class TabLineComponent extends Component{
  constructor(props){
    super(props);
    this.state = {
      option:{},
      txt:"三个月",
      historyData:{HistoryRate:[]},
      threeMonthDate:[],
      threeMonthNav:[],
      oneYearDate:[],
      oneYearNav:[],
      totalDate:[],
      totalNav:[],
      data1:[],
      data2:[],
      newDate:null,
      newNav:null
    }
  }
  historyCallback(data){
  	console.log( data, "历史净值" )

    let that = this;
    this.handleData(data);
  }
  componentDidMount() {
    let { dispatch } = this.props;
    let historyJoin = {
        type:1,
        fundcode:this.props.fundvalue
    }

    dispatch(getHistoryProfileRate(historyJoin,this.historyCallback.bind(this))); 
  }
  handleData(data){
    let fundtype = this.props.dataInfo;
    /* let touzFx = getFx(fundtype);*/
    let touzFx = "";
    let Datacontnet = data.HistoryRate;

    let threeMonthDate = this.state.threeMonthDate;
    let threeMonthNav = this.state.threeMonthNav;
    let oneYearDate = this.state.oneYearDate;
    let oneYearNav = this.state.oneYearNav;
    let totalDate = this.state.totalDate;
    let totalNav = this.state.totalNav;

    if(totalNav.length == 0){
      threeMonthDate = [];
      threeMonthNav = [];
      oneYearDate = [];
      oneYearNav = [];
      totalDate = [];
      totalNav = [];
      let oneYear = get1yearBefor();
      let threeMonth = get3MonthBefor();
      for(let i=Datacontnet.length-1; i>=0; i--){
        totalDate.push(Datacontnet[i].publish_date.substr(2));
        // if(touzFx != "低"){
          totalNav.push(Datacontnet[i].value_134)
        // }else{
        //   totalNav.push(Datacontnet[i].value_2_1)
        // }
        if(compareTime(oneYear, Datacontnet[i].publish_date)){
          oneYearDate.push(Datacontnet[i].publish_date.substr(2));
          // if(touzFx != "低"){
            oneYearNav.push(Datacontnet[i].value_134)
          // }else{
          //   oneYearNav.push(Datacontnet[i].value_2_1)
          // }
          if(compareTime(threeMonth, Datacontnet[i].publish_date)){
            threeMonthDate.push(Datacontnet[i].publish_date.substr(2));
            // if(touzFx != "低"){
              threeMonthNav.push(Datacontnet[i].value_134)
            // }else{
            //   threeMonthNav.push(Datacontnet[i].value_2_1)
            // }
          }
        }
      }
      
      threeMonthDate= threeMonthDate.reverse(),
      threeMonthNav= threeMonthNav.reverse(),
      oneYearDate= oneYearDate.reverse(),
      oneYearNav = oneYearNav.reverse(),
      totalNav=totalNav.reverse(),
      totalDate=totalDate.reverse()
      this.setState({
        threeMonthDate: threeMonthDate,
        threeMonthNav: threeMonthNav,
        oneYearDate: oneYearDate,
        oneYearNav : oneYearNav,
        totalNav:totalNav,
        totalDate:totalDate,
        option:lineOption(threeMonthDate,threeMonthNav),
        data1:threeMonthDate,
        data2:threeMonthNav,
        newDate:threeMonthDate[threeMonthDate.length-1],
        newNav:threeMonthNav[threeMonthNav.length-1]
      });
    }
  }
  handleTab(a){
    let fundtype = this.props.dataInfo;
    let touzFx = getFx(fundtype);
    // var myChart = echarts.init(document.getElementById('PublicOfferLine'));
    // myChart.clear();
    //document.getElementById('PublicOfferLine').innerHTML = "";
    //var myChart = echarts.init(document.getElementById('PublicOfferLine'));

    let that = this;
    if(a=="三个月"){
      // UmengStatis.onEvent('PublicOffering_ThreeMonth_Btn'); /*公募详情-三个月按钮*/
      let threeMonthDate = this.state.threeMonthDate;
      let threeMonthNav = this.state.threeMonthNav;
      that.setState({
        txt:"三个月",
        data1:this.state.threeMonthDate,
        data2:this.state.threeMonthNav,
        newDate:threeMonthDate[threeMonthDate.length-1],
        newNav:threeMonthNav[threeMonthNav.length-1]
      })


    }else if(a === "近一年"){ 
      // UmengStatis.onEvent('PublicOffering_OneYears_Btn'); /*公募详情-近一年按钮*/
      let { oneYearDate, oneYearNav } = this.state;
      that.setState({
        txt:"近一年",
        data1:this.state.oneYearDate,
        data2:this.state.oneYearNav,
        newDate:oneYearDate[oneYearDate.length-1],
        newNav:oneYearNav[oneYearNav.length-1]
      })
      // 绘制图表
      //myChart.setOption(lineOption(this.state.oneYearDate,this.state.oneYearNav));

    }else if(a === "成立以来"){
      // UmengStatis.onEvent('PublicOffering_AllYears_Btn'); /*公募详情-成立以来按钮*/
      let { totalDate, totalNav } = this.state;
      that.setState({
        txt:"成立以来",
        data1:this.state.totalDate,
        data2:this.state.totalNav,
        newDate:totalDate[totalDate.length-1],
        newNav:totalNav[totalNav.length-1]
      })
      //myChart.setOption(lineOption(this.state.totalDate,this.state.totalNav));
    }
  }
  render(){
    let fundtype = this.props.dataInfo;
    let touzFx = getFx(fundtype);
    let data = this.props.data;
    let { data1, data2, txt , newDate, newNav } = this.state;

    return(
      <div>
          <div style={{ background:"#FFF", position:"relative" }}>
            <div className="tabLinTitle">
              <span className={ txt === "三个月" ? "clickTab" : "" } onClick={ ()=>{ this.handleTab("三个月") }} >三个月</span>
              <span className={ txt === "近一年" ? "clickTab" : "" } onClick={ ()=>{ this.handleTab("近一年") }}>近一年</span>
              <span className={ txt === "成立以来" ? "clickTab" : "" } onClick={ ()=>{ this.handleTab("成立以来") }}>成立以来</span>
            </div>
            <div style={{ position:"absolute", right:0, top:"40px", backgroundColor:'rgba(255,255,255,0)', width:width }}>
              <div className="linePositionTop" style={{width:width}}>
                <div><span style={{ color:"rgb(161,168,179)", fontSize:11 }} >{ "" }</span><span style={{ color:"rgb(249,98,94)", fontSize:11 }}>{ "" }</span></div>
                <div>
                  <span style={{fontSize:11, color:'rgba(161,168,179,1)'}}> { newDate !=null ? newDate + "单位净值：" : null }</span><span style={{fontSize:11,color:"rgb(249,98,94)" }}>{ newNav !=null &&  newNav !="--" ? newNav +"%" : null  }</span>
                </div>
              </div>
            </div>
            <LineComponent data1 = { data1 } data2 = { data2 } /> 
          </div>
      </div>
    )
  }
}

/*累计净值*/
class TabLineComponentTwo extends Component{
  constructor(props){
    super(props);
    this.state = {
      option:{},
      txt:"三个月",
      historyData:{HistoryRate:[]},
      threeMonthDate:[],
      threeMonthNav:[],
      oneYearDate:[],
      oneYearNav:[],
      totalDate:[],
      totalNav:[],
      data1:[],
      data2:[]
    }
  }
  historyCallback(data){
  	console.log( data, "历史净值" )

    let that = this;
    this.handleData(data);
  }
  componentDidMount() {
    let { dispatch } = this.props;
     console.log(this.props.fundvalue,"historyCallbackhistoryCallbackhistoryCallback")
    // InteractionManager.runAfterInteractions(() => {
    //   dispatch(getHistoryProfileRate(history,this.historyCallback.bind(this)));
    // });
    let historyJoin = {
        type:1,
        fundcode:this.props.fundvalue
    }

    dispatch(getHistoryProfileRate(historyJoin,this.historyCallback.bind(this))); 
  }
  handleData(data){
    let fundtype = this.props.dataInfo;
    /* let touzFx = getFx(fundtype);*/
    let touzFx = "";
    let Datacontnet = data.HistoryRate;

    let threeMonthDate = this.state.threeMonthDate;
    let threeMonthNav = this.state.threeMonthNav;
    let oneYearDate = this.state.oneYearDate;
    let oneYearNav = this.state.oneYearNav;
    let totalDate = this.state.totalDate;
    let totalNav = this.state.totalNav;

    if(totalNav.length == 0){
      threeMonthDate = [];
      threeMonthNav = [];
      oneYearDate = [];
      oneYearNav = [];
      totalDate = [];
      totalNav = [];
      let oneYear = get1yearBefor();
      let threeMonth = get3MonthBefor();
      for(let i=Datacontnet.length-1; i>=0; i--){
        totalDate.push(Datacontnet[i].publish_date.substr(2));
        // if(touzFx != "低"){
          totalNav.push(Datacontnet[i].value_134_2)
        // }else{
        //   totalNav.push(Datacontnet[i].value_2_1)
        // }
        if(compareTime(oneYear, Datacontnet[i].publish_date)){
          oneYearDate.push(Datacontnet[i].publish_date.substr(2));
          // if(touzFx != "低"){
            oneYearNav.push(Datacontnet[i].value_134_2)
          // }else{
          //   oneYearNav.push(Datacontnet[i].value_2_1)
          // }
          if(compareTime(threeMonth, Datacontnet[i].publish_date)){
            threeMonthDate.push(Datacontnet[i].publish_date.substr(2));
            // if(touzFx != "低"){
              threeMonthNav.push(Datacontnet[i].value_134_2)
            // }else{
            //   threeMonthNav.push(Datacontnet[i].value_2_1)
            // }
          }
        }
      }
      
      threeMonthDate= threeMonthDate.reverse(),
      threeMonthNav= threeMonthNav.reverse(),
      oneYearDate= oneYearDate.reverse(),
      oneYearNav = oneYearNav.reverse(),
      totalNav=totalNav.reverse(),
      totalDate=totalDate.reverse()
      this.setState({
        threeMonthDate: threeMonthDate,
        threeMonthNav: threeMonthNav,
        oneYearDate: oneYearDate,
        oneYearNav : oneYearNav,
        totalNav:totalNav,
        totalDate:totalDate,
        option:lineOption(threeMonthDate,threeMonthNav),
        data1:threeMonthDate,
        data2:threeMonthNav,
      });
    }
  }
  handleTab(a){
    let fundtype = this.props.dataInfo;
    let touzFx = getFx(fundtype);
    // var myChart = echarts.init(document.getElementById('PublicOfferLine'));
    // myChart.clear();
    //document.getElementById('PublicOfferLine').innerHTML = "";
    //var myChart = echarts.init(document.getElementById('PublicOfferLine'));

    let that = this;
    if(a=="三个月"){
      // UmengStatis.onEvent('PublicOffering_ThreeMonth_Btn'); /*公募详情-三个月按钮*/
      that.setState({
        txt:"三个月",
        data1:this.state.threeMonthDate,
        data2:this.state.threeMonthNav,
      })


    }else if(a === "近一年"){ 
      // UmengStatis.onEvent('PublicOffering_OneYears_Btn'); /*公募详情-近一年按钮*/
      that.setState({
        txt:"近一年",
        data1:this.state.oneYearDate,
        data2:this.state.oneYearNav,
      })
      // 绘制图表
      //myChart.setOption(lineOption(this.state.oneYearDate,this.state.oneYearNav));
    }else if(a === "成立以来"){
      // UmengStatis.onEvent('PublicOffering_AllYears_Btn'); /*公募详情-成立以来按钮*/
      that.setState({
        txt:"成立以来",
        data1:this.state.totalDate,
        data2:this.state.totalNav,
      })
      //myChart.setOption(lineOption(this.state.totalDate,this.state.totalNav));
    }
  }
  render(){
    let fundtype = this.props.dataInfo;
    let touzFx = getFx(fundtype);
    let data = this.props.data;
    let { data1, data2, txt } = this.state;

    return(
      <div>
          <div style={{ background:"#FFF"}}>
            <div className="tabLinTitle">
              <span className={ txt === "三个月" ? "clickTab" : "" } onClick={ ()=>{ this.handleTab("三个月") }} >三个月</span>
              <span className={ txt === "近一年" ? "clickTab" : "" } onClick={ ()=>{ this.handleTab("近一年") }}>近一年</span>
              <span className={ txt === "成立以来" ? "clickTab" : "" } onClick={ ()=>{ this.handleTab("成立以来") }}>成立以来</span>
            </div>
            <LineComponent data1 = { data1 } data2 = { data2 } /> 
          </div>
      </div>
    )
  }
}


/*货币*/
class TabLineComponentH extends Component{
  constructor(props){
    super(props);
    this.state = {
      option:{},
      txt:"三个月",
      historyData:{HistoryRate:[]},
      threeMonthDate:[],
      threeMonthNav:[],
      oneYearDate:[],
      oneYearNav:[],
      totalDate:[],
      totalNav:[],
      data1:[],
      data2:[]
    }
  }
  historyCallback(data){
  	console.log( data, "历史净值" )

    let that = this;
    this.handleData(data);
  }
  componentDidMount() {
    let { dispatch } = this.props;  
    let historyJoin = {
        type:1,
        fundcode:this.props.fundvalue
    }

    dispatch(getHistoryProfileRate(historyJoin,this.historyCallback.bind(this))); 
  }
  handleData(data){
    let fundtype = this.props.dataInfo;
    /* let touzFx = getFx(fundtype);*/
    let touzFx = "";
    let Datacontnet = data.HistoryRate;

    let threeMonthDate = this.state.threeMonthDate;
    let threeMonthNav = this.state.threeMonthNav;
    let oneYearDate = this.state.oneYearDate;
    let oneYearNav = this.state.oneYearNav;
    let totalDate = this.state.totalDate;
    let totalNav = this.state.totalNav;

    if(totalNav.length == 0){
      threeMonthDate = [];
      threeMonthNav = [];
      oneYearDate = [];
      oneYearNav = [];
      totalDate = [];
      totalNav = [];
      let oneYear = get1yearBefor();
      let threeMonth = get3MonthBefor();
      for(let i=Datacontnet.length-1; i>=0; i--){
        totalDate.push(Datacontnet[i].publish_date.substr(2));
        // if(touzFx != "低"){
          totalNav.push(Datacontnet[i].value_2_1)
        // }else{
        //   totalNav.push(Datacontnet[i].value_2_1)
        // }
        if(compareTime(oneYear, Datacontnet[i].publish_date)){
          oneYearDate.push(Datacontnet[i].publish_date.substr(2));
          // if(touzFx != "低"){
            oneYearNav.push(Datacontnet[i].value_2_1)
          // }else{
          //   oneYearNav.push(Datacontnet[i].value_2_1)
          // }
          if(compareTime(threeMonth, Datacontnet[i].publish_date)){
            threeMonthDate.push(Datacontnet[i].publish_date.substr(2));
            // if(touzFx != "低"){
              threeMonthNav.push(Datacontnet[i].value_2_1)
            // }else{
            //   threeMonthNav.push(Datacontnet[i].value_2_1)
            // }
          }
        }
      }
      
      threeMonthDate= threeMonthDate.reverse(),
      threeMonthNav= threeMonthNav.reverse(),
      oneYearDate= oneYearDate.reverse(),
      oneYearNav = oneYearNav.reverse(),
      totalNav=totalNav.reverse(),
      totalDate=totalDate.reverse()
      this.setState({
        threeMonthDate: threeMonthDate,
        threeMonthNav: threeMonthNav,
        oneYearDate: oneYearDate,
        oneYearNav : oneYearNav,
        totalNav:totalNav,
        totalDate:totalDate,
        option:lineOption(threeMonthDate,threeMonthNav),
        data1:threeMonthDate,
        data2:threeMonthNav
      });
    }
  }
  handleTab(a){
    let fundtype = this.props.dataInfo;
    let touzFx = getFx(fundtype);
    // var myChart = echarts.init(document.getElementById('PublicOfferLine'));
    // myChart.clear();
    //document.getElementById('PublicOfferLine').innerHTML = "";
    //var myChart = echarts.init(document.getElementById('PublicOfferLine'));

    let that = this;
    if(a=="三个月"){

      that.setState({
        txt:"三个月",
        data1:this.state.threeMonthDate,
        data2:this.state.threeMonthNav,
      })


    }else if(a === "近一年"){ 

      that.setState({
        txt:"近一年",
        data1:this.state.oneYearDate,
        data2:this.state.oneYearNav,
      })
      // 绘制图表
      //myChart.setOption(lineOption(this.state.oneYearDate,this.state.oneYearNav));

    }else if(a === "成立以来"){
      // UmengStatis.onEvent('PublicOffering_AllYears_Btn'); /*公募详情-成立以来按钮*/
      that.setState({
        txt:"成立以来",
        data1:this.state.totalDate,
        data2:this.state.totalNav,
      })
      //myChart.setOption(lineOption(this.state.totalDate,this.state.totalNav));
    }
  }
  render(){
    let fundtype = this.props.dataInfo;
    let touzFx = getFx(fundtype);
    let data = this.props.data;
    let { data1, data2, txt } = this.state;

    return(
      <div>
          <div style={{ background:"#FFF"}}>
            <div className="tabLinTitle">
              <span className={ txt === "三个月" ? "clickTab" : "" } onClick={ ()=>{ this.handleTab("三个月") }} >三个月</span>
              <span className={ txt === "近一年" ? "clickTab" : "" } onClick={ ()=>{ this.handleTab("近一年") }}>近一年</span>
              <span className={ txt === "成立以来" ? "clickTab" : "" } onClick={ ()=>{ this.handleTab("成立以来") }}>成立以来</span>
            </div>
            <LineComponent data1 = { data1 } data2 = { data2 } /> 
          </div>
      </div>
    )
  }
}

/*货币*/
class TabLineComponentHTwo extends Component{
  constructor(props){
    super(props);
    this.state = {
      option:{},
      txt:"三个月",
      historyData:{HistoryRate:[]},
      threeMonthDate:[],
      threeMonthNav:[],
      oneYearDate:[],
      oneYearNav:[],
      totalDate:[],
      totalNav:[],
      data1:[],
      data2:[]
    }
  }
  historyCallback(data){
  	console.log( data, "历史净值" )

    let that = this;
    this.handleData(data);
  }
  componentDidMount() {
    let { dispatch } = this.props;
    let historyJoin = {
        type:1,
        fundcode:this.props.fundvalue
    }

    dispatch(getHistoryProfileRate(historyJoin,this.historyCallback.bind(this))); 
  }
  handleData(data){
    let fundtype = this.props.dataInfo;
    /* let touzFx = getFx(fundtype);*/
    let touzFx = "";
    let Datacontnet = data.HistoryRate;

    let threeMonthDate = this.state.threeMonthDate;
    let threeMonthNav = this.state.threeMonthNav;
    let oneYearDate = this.state.oneYearDate;
    let oneYearNav = this.state.oneYearNav;
    let totalDate = this.state.totalDate;
    let totalNav = this.state.totalNav;

    if(totalNav.length == 0){
      threeMonthDate = [];
      threeMonthNav = [];
      oneYearDate = [];
      oneYearNav = [];
      totalDate = [];
      totalNav = [];
      let oneYear = get1yearBefor();
      let threeMonth = get3MonthBefor();
      for(let i=Datacontnet.length-1; i>=0; i--){
        totalDate.push(Datacontnet[i].publish_date.substr(2));
        // if(touzFx != "低"){
          totalNav.push(Datacontnet[i].value_2_2)
        // }else{
        //   totalNav.push(Datacontnet[i].value_2_1)
        // }
        if(compareTime(oneYear, Datacontnet[i].publish_date)){
          oneYearDate.push(Datacontnet[i].publish_date.substr(2));
          // if(touzFx != "低"){
            oneYearNav.push(Datacontnet[i].value_2_2)
          // }else{
          //   oneYearNav.push(Datacontnet[i].value_2_1)
          // }
          if(compareTime(threeMonth, Datacontnet[i].publish_date)){
            threeMonthDate.push(Datacontnet[i].publish_date.substr(2));
            // if(touzFx != "低"){
              threeMonthNav.push(Datacontnet[i].value_2_2)
            // }else{
            //   threeMonthNav.push(Datacontnet[i].value_2_1)
            // }
          }
        }
      }
      
      threeMonthDate= threeMonthDate.reverse(),
      threeMonthNav= threeMonthNav.reverse(),
      oneYearDate= oneYearDate.reverse(),
      oneYearNav = oneYearNav.reverse(),
      totalNav=totalNav.reverse(),
      totalDate=totalDate.reverse()
      this.setState({
        threeMonthDate: threeMonthDate,
        threeMonthNav: threeMonthNav,
        oneYearDate: oneYearDate,
        oneYearNav : oneYearNav,
        totalNav:totalNav,
        totalDate:totalDate,
        option:lineOption(threeMonthDate,threeMonthNav),
        data1:threeMonthDate,
        data2:threeMonthNav
      });
    }
  }
  handleTab(a){
    let fundtype = this.props.dataInfo;
    let touzFx = getFx(fundtype);
    // var myChart = echarts.init(document.getElementById('PublicOfferLine'));
    // myChart.clear();
    //document.getElementById('PublicOfferLine').innerHTML = "";
    //var myChart = echarts.init(document.getElementById('PublicOfferLine'));

    let that = this;
    if(a=="三个月"){
      // UmengStatis.onEvent('PublicOffering_ThreeMonth_Btn'); /*公募详情-三个月按钮*/
      that.setState({
        txt:"三个月",
        data1:this.state.threeMonthDate,
        data2:this.state.threeMonthNav,
      })


    }else if(a === "近一年"){ 
      // UmengStatis.onEvent('PublicOffering_OneYears_Btn'); /*公募详情-近一年按钮*/
      that.setState({
        txt:"近一年",
        data1:this.state.oneYearDate,
        data2:this.state.oneYearNav,
      })
      // 绘制图表
      //myChart.setOption(lineOption(this.state.oneYearDate,this.state.oneYearNav));

    }else if(a === "成立以来"){
      // UmengStatis.onEvent('PublicOffering_AllYears_Btn'); /*公募详情-成立以来按钮*/
      that.setState({
        txt:"成立以来",
        data1:this.state.totalDate,
        data2:this.state.totalNav,
      })
      //myChart.setOption(lineOption(this.state.totalDate,this.state.totalNav));
    }
  }
  render(){
    let fundtype = this.props.dataInfo;
    let touzFx = getFx(fundtype);
    let data = this.props.data;
    let { data1, data2, txt } = this.state;

    return(
      <div>
          <div style={{ background:"#FFF"}}>
            <div className="tabLinTitle">
              <span className={ txt === "三个月" ? "clickTab" : "" } onClick={ ()=>{ this.handleTab("三个月") }} >三个月</span>
              <span className={ txt === "近一年" ? "clickTab" : "" } onClick={ ()=>{ this.handleTab("近一年") }}>近一年</span>
              <span className={ txt === "成立以来" ? "clickTab" : "" } onClick={ ()=>{ this.handleTab("成立以来") }}>成立以来</span>
            </div>
            <LineComponent data1 = { data1 } data2 = { data2 } /> 
          </div>
      </div>
    )
  }
}


/*折线图option*/
export function lineOption(dataName,dataSouce){
  let option={
          title: {
              text: ''
          },
          grid:{
            y:'13%',
            left:37
          },
          // tooltip: {},
          // legend: {
          //     data:[]
          // },
          tooltip : {
          show:true,
          trigger: 'axis',
          alwaysShowContent:true,
          position:[width/2,0],
          padding:[16,300,0,23],
          axisPointer:{
                type: 'line',
                lineStyle: {
                    color: '#48b',
                    width: 1,
                    type: 'dashed'
                },
                crossStyle: {
                    color: '#1e90ff',
                    width: 1,
                    type: 'dashed'
                },
                shadowStyle: {
                    color: 'rgba(150,150,150,0.3)',
                    width: 'auto',
                    type: 'default'
                }
          },
          backgroundColor:"#FFF",
          textStyle:{
            fontSize:11,
            paddingLeft:5,
            paddingRight:5,
          },
          formatter:'<div style="color:rgb(161,168,179); paddingLeft:20;font-size:11" ><span > {b}</span>{a0}：<span style=color:'+`${true?'rgb(249,98,94)':'#f0f'}`+'>{c0}%</span> </div>'
          //{`<div style="color:rgb(161,168,179)" ><span>{b}</span>{a0}：<span style=${true ? 'color:red' : 'color:blue' } >{c0}%</span></div>`}
          // function(params,ticket,callBack) {
          //     var result = '';
          //     // params.forEach(function (item) {
          //     //     result =  item.name + ":" + item.data;
          //     // });
          //     result = params[0].name + params[0].data
          //     return result;
          // }
        },
          xAxis : [
            {
                type : 'category',
                boundaryGap : false,
                data :dataName,
                // name:'(年份)',
                axisLine:{
                    lineStyle:{
                        width:1,
                        color:"#CCC"
                    }
                },
                axisTick:{
                     lineStyle:{
                        width:0,
                        color:"#9BC4D8"
                    }
                },
            }
          ],
          axis:[
            {
                axisLline:{
                    show:true,
                    lineStyle:{
                         color: '#99C4D7',
                        width: 2,
                        type: 'dashed'
                    }
                },
                splitArea:{
                    areaStyle:{
                        color: [
                            'rgba(250,250,250,0.3)',
                            'rgba(200,200,200,0.3)'
                        ]
                    }
                }
            },
          ],
          yAxis : [
            {
                type : 'value',
                scale: true,
                // name:'(人)',
                axisLine:{
                    lineStyle:{
                        width:0,
                        color:"rgb(160,167,176)"
                    }
                },
                axisTick:{
                     lineStyle:{
                        width:0,
                        color:"#9BC4D8"
                    }
                },
                axisLabel: {
                    rotate:0,
                    formatter: '{value}'
                }
            }
        ],
        series: [{
            name: '单位净值',
            type: 'line',
            smooth:true,
            hoverAnimation:false,
            data: dataSouce,
            itemStyle : {  
                normal : {  
                    color:'#fa063a',  /*#53C6E0*/
                    lineStyle:{  
                        color:'#fa063a'  
                    }  
                }  
            }, 
        }]
      }
      return option;
}

/*折线图option*/
export function lineOptionL(dataName,dataSouce){
  let option={
          title: {
              text: ''
          },
          grid:{
            y:'13%',
            left:37
          },
          // tooltip: {},
          // legend: {
          //     data:[]
          // },
          tooltip : {
          show:true,
          trigger: 'axis',
          alwaysShowContent:true,
          position:[width/2,0],
          padding:[16,300,0,23],
          axisPointer:{
                type: 'line',
                lineStyle: {
                    color: '#48b',
                    width: 1,
                    type: 'dashed'
                },
                crossStyle: {
                    color: '#1e90ff',
                    width: 1,
                    type: 'dashed'
                },
                shadowStyle: {
                    color: 'rgba(150,150,150,0.3)',
                    width: 'auto',
                    type: 'default'
                }
          },
          backgroundColor:"#FFF",
          textStyle:{
            fontSize:11,
            paddingLeft:5,
            paddingRight:5,
          },
          formatter:'<div style="color:rgb(161,168,179); paddingLeft:20;font-size:11" ><span > {b}</span>{a0}：<span style=color:'+`${true?'rgb(249,98,94)':'#f0f'}`+'>{c0}%</span> </div>'
          //{`<div style="color:rgb(161,168,179)" ><span>{b}</span>{a0}：<span style=${true ? 'color:red' : 'color:blue' } >{c0}%</span></div>`}
          // function(params,ticket,callBack) {
          //     var result = '';
          //     // params.forEach(function (item) {
          //     //     result =  item.name + ":" + item.data;
          //     // });
          //     result = params[0].name + params[0].data
          //     return result;
          // }
        },
          xAxis : [
            {
                type : 'category',
                boundaryGap : false,
                data :dataName,
                // name:'(年份)',
                axisLine:{
                    lineStyle:{
                        width:1,
                        color:"#CCC"
                    }
                },
                axisTick:{
                     lineStyle:{
                        width:0,
                        color:"#9BC4D8"
                    }
                },
            }
          ],
          axis:[
            {
                axisLline:{
                    show:true,
                    lineStyle:{
                         color: '#99C4D7',
                        width: 2,
                        type: 'dashed'
                    }
                },
                splitArea:{
                    areaStyle:{
                        color: [
                            'rgba(250,250,250,0.3)',
                            'rgba(200,200,200,0.3)'
                        ]
                    }
                }
            },
          ],
          yAxis : [
            {
                type : 'value',
                scale: true,
                // name:'(人)',
                axisLine:{
                    lineStyle:{
                        width:0,
                        color:"rgb(160,167,176)"
                    }
                },
                axisTick:{
                     lineStyle:{
                        width:0,
                        color:"#9BC4D8"
                    }
                },
                axisLabel: {
                    rotate:0,
                    formatter: '{value}'
                }
            }
        ],
        series: [{
            name: '累计净值',
            type: 'line',
            smooth:true,
            hoverAnimation:false,
            data: dataSouce,
            itemStyle : {  
                normal : {  
                    color:'#fa063a',  /*#53C6E0*/
                    lineStyle:{  
                        color:'#fa063a'  
                    }  
                }  
            }, 
        }]
      }
      return option;
}

/*折线图option 万份收益*/
export function lineOptionW(dataName,dataSouce){
  let option={
          title: {
              text: ''
          },
          grid:{
            y:'13%',
            left:37
          },
          // tooltip: {},
          // legend: {
          //     data:[]
          // },
          tooltip : {
          show:true,
          trigger: 'axis',
          alwaysShowContent:true,
          position:[width/2,0],
          padding:[16,300,0,23],
          axisPointer:{
                type: 'line',
                lineStyle: {
                    color: '#48b',
                    width: 1,
                    type: 'dashed'
                },
                crossStyle: {
                    color: '#1e90ff',
                    width: 1,
                    type: 'dashed'
                },
                shadowStyle: {
                    color: 'rgba(150,150,150,0.3)',
                    width: 'auto',
                    type: 'default'
                }
          },
          backgroundColor:"#FFF",
          textStyle:{
            fontSize:11,
            paddingLeft:5,
            paddingRight:5,
          },
          formatter:'<div style="color:rgb(161,168,179); paddingLeft:20;font-size:11" ><span > {b}</span>{a0}：<span style=color:'+`${true?'rgb(249,98,94)':'#f0f'}`+'>{c0}%</span> </div>'
          //{`<div style="color:rgb(161,168,179)" ><span>{b}</span>{a0}：<span style=${true ? 'color:red' : 'color:blue' } >{c0}%</span></div>`}
          // function(params,ticket,callBack) {
          //     var result = '';
          //     // params.forEach(function (item) {
          //     //     result =  item.name + ":" + item.data;
          //     // });
          //     result = params[0].name + params[0].data
          //     return result;
          // }
        },
          xAxis : [
            {
                type : 'category',
                boundaryGap : false,
                data :dataName,
                // name:'(年份)',
                axisLine:{
                    lineStyle:{
                        width:1,
                        color:"#CCC"
                    }
                },
                axisTick:{
                     lineStyle:{
                        width:0,
                        color:"#9BC4D8"
                    }
                },
            }
          ],
          axis:[
            {
                axisLline:{
                    show:true,
                    lineStyle:{
                         color: '#99C4D7',
                        width: 2,
                        type: 'dashed'
                    }
                },
                splitArea:{
                    areaStyle:{
                        color: [
                            'rgba(250,250,250,0.3)',
                            'rgba(200,200,200,0.3)'
                        ]
                    }
                }
            },
          ],
          yAxis : [
            {
                type : 'value',
                scale: true,
                // name:'(人)',
                axisLine:{
                    lineStyle:{
                        width:0,
                        color:"rgb(160,167,176)"
                    }
                },
                axisTick:{
                     lineStyle:{
                        width:0,
                        color:"#9BC4D8"
                    }
                },
                axisLabel: {
                    rotate:0,
                    formatter: '{value}'
                }
            }
        ],
        series: [{
            name: '万份收益',
            type: 'line',
            smooth:true,
            hoverAnimation:false,
            data: dataSouce,
            itemStyle : {  
                normal : {  
                    color:'#fa063a',  /*#53C6E0*/
                    lineStyle:{  
                        color:'#fa063a'  
                    }  
                }  
            }, 
        }]
      }
      return option;
}

/*折线图option 七日年化*/
export function lineOptionQ(dataName,dataSouce){
  let option={
          title: {
              text: ''
          },
          grid:{
            y:'13%',
            left:37
          },
          // tooltip: {},
          // legend: {
          //     data:[]
          // },
          tooltip : {
          show:true,
          trigger: 'axis',
          alwaysShowContent:true,
          position:[width/2,0],
          padding:[16,300,0,23],
          axisPointer:{
                type: 'line',
                lineStyle: {
                    color: '#48b',
                    width: 1,
                    type: 'dashed'
                },
                crossStyle: {
                    color: '#1e90ff',
                    width: 1,
                    type: 'dashed'
                },
                shadowStyle: {
                    color: 'rgba(150,150,150,0.3)',
                    width: 'auto',
                    type: 'default'
                }
          },
          backgroundColor:"#FFF",
          textStyle:{
            fontSize:11,
            paddingLeft:5,
            paddingRight:5,
          },
          formatter:'<div style="color:rgb(161,168,179); paddingLeft:20;font-size:11" ><span > {b}</span>{a0}：<span style=color:'+`${true?'rgb(249,98,94)':'#f0f'}`+'>{c0}%</span> </div>'
          //{`<div style="color:rgb(161,168,179)" ><span>{b}</span>{a0}：<span style=${true ? 'color:red' : 'color:blue' } >{c0}%</span></div>`}
          // function(params,ticket,callBack) {
          //     var result = '';
          //     // params.forEach(function (item) {
          //     //     result =  item.name + ":" + item.data;
          //     // });
          //     result = params[0].name + params[0].data
          //     return result;
          // }
        },
          xAxis : [
            {
                type : 'category',
                boundaryGap : false,
                data :dataName,
                // name:'(年份)',
                axisLine:{
                    lineStyle:{
                        width:1,
                        color:"#CCC"
                    }
                },
                axisTick:{
                     lineStyle:{
                        width:0,
                        color:"#9BC4D8"
                    }
                },
            }
          ],
          axis:[
            {
                axisLline:{
                    show:true,
                    lineStyle:{
                         color: '#99C4D7',
                        width: 2,
                        type: 'dashed'
                    }
                },
                splitArea:{
                    areaStyle:{
                        color: [
                            'rgba(250,250,250,0.3)',
                            'rgba(200,200,200,0.3)'
                        ]
                    }
                }
            },
          ],
          yAxis : [
            {
                type : 'value',
                scale: true,
                // name:'(人)',
                axisLine:{
                    lineStyle:{
                        width:0,
                        color:"rgb(160,167,176)"
                    }
                },
                axisTick:{
                     lineStyle:{
                        width:0,
                        color:"#9BC4D8"
                    }
                },
                axisLabel: {
                    rotate:0,
                    formatter: '{value}'
                }
            }
        ],
        series: [{
            name: '七日年化',
            type: 'line',
            smooth:true,
            hoverAnimation:false,
            data: dataSouce,
            itemStyle : {  
                normal : {  
                    color:'#fa063a',  /*#53C6E0*/
                    lineStyle:{  
                        color:'#fa063a'  
                    }  
                }  
            }, 
        }]
      }
      return option;
}


function getFx(fundtype){
  let touzFx = "";
  if(fundtype == "股票型" || fundtype == "指数型"){
    touzFx = "高"
  }else if(fundtype == "混合型" || fundtype == "债券型"){
    touzFx = "中"
  }else if(fundtype == "货币型" || fundtype == "理财型"){
    touzFx = "低"
  }
  return  touzFx;
}





// WEBPACK FOOTER //
// ./src/components/product/Details/PublicOffering.js